// #32 Tag: a small uppercase-free word on the neutral tint (a source name, *Revised*); `limited` and `internal` carry
// the permission matrix's words on their own forms (O-5, O-8): Limited dashed and neutral, Internal on purple.

import type { ReactNode } from "react";
import { cx } from "../lib/cx";

export interface TagProps {
  children: ReactNode;
  tone?: "limited" | "internal" | undefined;
  className?: string | undefined;
}

export function Tag({ children, tone, className }: TagProps) {
  return <span className={cx("mc-tag", tone && `mc-tag-${tone}`, className)}>{children}</span>;
}
